export default __webpack_public_path__ + "static/media/1801.fa58409f.png";